$(function () { 
    
    // ACCORDION Toggle (Multiple Items)
    if($('.acc .acc-head').length > 0)
    {
        $('.acc .acc-head').click(function(){
            var parent = $(this).parent();        
            parent.toggleClass('active');
            parent.find('.acc-info').stop().slideToggle();
            parent.siblings().find('.acc-info').hide();
            parent.siblings().removeClass('active');
        }); 
    }   
    
    
    // Parent Panel
    if ($('.panel .panel-head').length > 0) {
        $('.panel .panel-head').click(function () {
            var parent = $(this).parent();

            // Baaki parent panels close karo
            $('.panel').not(parent).removeClass('panel-active').find('.panel-body').slideUp();

            parent.toggleClass('panel-active');
            parent.find('.panel-body').stop().slideToggle();
        });
    }
});




